var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { cn } from '@lux/core';
export var SvgIcon = function (props) {
    var children = props.children, className = props.className, viewBox = props.viewBox, preserveAspectRatio = props.preserveAspectRatio, width = props.width, height = props.height, fill = props.fill;
    var dimensionsStyles = width && height ? { width: width, height: height } : null;
    return (React.createElement("svg", __assign({ className: cn('w-sm h-sm text-function-100 inline-block align-bottom', className), viewBox: viewBox, preserveAspectRatio: preserveAspectRatio, fill: fill }, (dimensionsStyles ? { style: dimensionsStyles } : {})), children));
};
export default SvgIcon;
